// logo
import gandara from "../../images/foto-divisi/logo-divisi/Gandara Large.png";
import balwana from "../../images/foto-divisi/logo-divisi/Balwana Large.png";
import caksana from "../../images/foto-divisi/logo-divisi/Caksana Large.png";
import lavanya from "../../images/foto-divisi/logo-divisi/Lavanya Large.png";
import bimasena from "../../images/foto-divisi/logo-divisi/Bimasena Large.png";
import baskara from "../../images/foto-divisi/logo-divisi/Baskara Large.png";
import gajendra from "../../images/foto-divisi/logo-divisi/Gajendra Large.png";
import sakha from "../../images/foto-divisi/logo-divisi/Sakha Large.png";
import nayanika from "../../images/foto-divisi/logo-divisi/Nayanika Large.png";
import sarkara from "../../images/foto-divisi/logo-divisi/Sarkara Large.png";
import saraya from "../../images/foto-divisi/logo-divisi/Saraya Large.png";


// foto
import gandara1 from "../../images/foto-divisi/dokumentasi-divisi/Gandara/foto1.jpeg";
import gandara2 from "../../images/foto-divisi/dokumentasi-divisi/Gandara/foto2.jpeg";
import gandara3 from "../../images/foto-divisi/dokumentasi-divisi/Gandara/foto3.jpeg";
import balwana1 from "../../images/foto-divisi/dokumentasi-divisi/Balwana/foto1.jpeg";
import balwana2 from "../../images/foto-divisi/dokumentasi-divisi/Balwana/foto2.jpeg";
import balwana3 from "../../images/foto-divisi/dokumentasi-divisi/Balwana/foto3.jpeg";
import caksana1 from "../../images/foto-divisi/dokumentasi-divisi/Caksana/foto1.jpeg";
import caksana2 from "../../images/foto-divisi/dokumentasi-divisi/Caksana/foto2.jpeg";
import caksana3 from "../../images/foto-divisi/dokumentasi-divisi/Caksana/foto3.jpeg";
import lavanya1 from "../../images/foto-divisi/dokumentasi-divisi/Lavanya/foto1.jpeg";
import lavanya2 from "../../images/foto-divisi/dokumentasi-divisi/Lavanya/foto2.jpeg";
import lavanya3 from "../../images/foto-divisi/dokumentasi-divisi/Lavanya/foto3.jpeg";
import bimasena1 from "../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto1.jpeg";
import bimasena2 from "../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto2.jpeg";
import bimasena3 from "../../images/foto-divisi/dokumentasi-divisi/Bimasena/foto3.jpeg";
import baskara1 from "../../images/foto-divisi/dokumentasi-divisi/Baskara/foto1.jpeg";
import baskara2 from "../../images/foto-divisi/dokumentasi-divisi/Baskara/foto2.jpeg";
import baskara3 from "../../images/foto-divisi/dokumentasi-divisi/Baskara/foto3.jpeg";
import gajendra1 from "../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto1.jpeg";
import gajendra2 from "../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto2.jpeg";
import gajendra3 from "../../images/foto-divisi/dokumentasi-divisi/Gajendra/foto3.jpeg";
import sakha1 from "../../images/foto-divisi/dokumentasi-divisi/Sakha/foto1.jpeg";
import sakha2 from "../../images/foto-divisi/dokumentasi-divisi/Sakha/foto2.jpeg";
import sakha3 from "../../images/foto-divisi/dokumentasi-divisi/Sakha/foto3.jpeg";
import nayanika1 from "../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto1.jpeg";
import nayanika2 from "../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto2.jpeg";
import nayanika3 from "../../images/foto-divisi/dokumentasi-divisi/Nayanika/foto3.jpeg";
import sarkara1 from "../../images/foto-divisi/dokumentasi-divisi/Sarkara/foto1.jpeg";
import sarkara2 from "../../images/foto-divisi/dokumentasi-divisi/Sarkara/foto2.jpeg";
import sarkara3 from "../../images/foto-divisi/dokumentasi-divisi/Sarkara/foto3.jpeg";
import saraya1 from "../../images/foto-divisi/dokumentasi-divisi/Saraya/foto1.jpeg";
import saraya2 from "../../images/foto-divisi/dokumentasi-divisi/Saraya/foto2.jpeg";
import saraya3 from "../../images/foto-divisi/dokumentasi-divisi/Saraya/foto3.jpeg";


const carouselData = {
    "DIVISI":[
        {
            nama: "Gandara",
            divisi: "Badan Pengurus Harian",
            logo: gandara,
            foto: [
                gandara1,
                gandara2,
                gandara3,
            ],
            warna: "biru",
        },
        {
            nama: "Balwana",
            divisi: "Acara",
            logo: balwana,
            foto: [
                balwana1,
                balwana2,
                balwana3,
            ],
            warna: "merah",
        },
        {
            nama: "Caksana",
            divisi: `<i>Public Relations</i>`,
            logo: caksana,
            foto: [
                caksana1,
                caksana2,
                caksana3,
            ],
            warna: "abu",
        },
        {
            nama: "Lavanya",
            divisi: "Desain",
            logo: lavanya,
            foto: [
                lavanya1,
                lavanya2,
                lavanya3,
            ],
            warna: "toska",
        },
        {
            nama: "Bimasena",
            divisi: "Keamanan",
            logo: bimasena,
            foto: [
                bimasena1,
                bimasena2,
                bimasena3,
            ],
            warna: "hitam",
        },
        {
            nama: "Baskara",
            divisi: "Dokumentasi",
            logo: baskara,
            foto: [
                baskara1,
                baskara2,
                baskara3,
            ],
            warna: "oranye",
        },
        {
            nama: "Gajendra",
            divisi: "Perlengkapan",
            logo: gajendra,
            foto: [
                gajendra1,
                gajendra2,
                gajendra3,
            ],
            warna: "ungu",
        },
        {
            nama: "Sakha",
            divisi: "PIC",
            logo: sakha,
            foto: [
                sakha1,
                sakha2,
                sakha3,
            ],
            warna: "pink",
        },
        {
            nama: "Nayanika",
            divisi: "Website",
            logo: nayanika,
            foto: [
                nayanika1,
                nayanika2,
                nayanika3,
            ],
            warna: "kuning",
        },
        {
            nama: "Sarkara",
            divisi: "Konsumsi",
            logo: sarkara,
            foto: [
                sarkara1,
                sarkara2,
                sarkara3,
            ],
            warna: "cokelat",
        },
        {
            nama: "Saraya",
            divisi: "Medis",
            logo: saraya,
            foto: [
                saraya1,
                saraya2,
                saraya3,
            ],
            warna: "hijau",
        }
    ]
}
export default carouselData